import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ScreenFeedbackComponent } from '@kp/screen-feedback/screen-feedback.component';

const routes: Routes = [{ path: '', pathMatch: 'full', component: ScreenFeedbackComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ScreenFeedbackRouteModule {
  static components = [ScreenFeedbackComponent];
}
